'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eannotation$002e$002dAnnotation from "./scala.annotation.-Annotation.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_NoPanel(asTable, fieldCss, labelCss, panelCss) {
  this.lC = false;
  this.rN = null;
  this.rO = null;
  this.rP = null;
  this.lC = asTable;
  this.rN = fieldCss;
  this.rO = labelCss;
  this.rP = panelCss;
}
export { $c_Ldev_cheleb_scalamigen_NoPanel as $c_Ldev_cheleb_scalamigen_NoPanel };
$p = $c_Ldev_cheleb_scalamigen_NoPanel.prototype = new $j_scala$002eannotation$002e$002dAnnotation.$h_s_annotation_Annotation();
$p.constructor = $c_Ldev_cheleb_scalamigen_NoPanel;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_NoPanel() {
}
export { $h_Ldev_cheleb_scalamigen_NoPanel as $h_Ldev_cheleb_scalamigen_NoPanel };
$h_Ldev_cheleb_scalamigen_NoPanel.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (-534440797));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (this.lC ? 1231 : 1237));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.rN));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.rO));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.rP));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 4);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Ldev_cheleb_scalamigen_NoPanel) && ((((this.lC === x$0.lC) && (this.rN === x$0.rN)) && (this.rO === x$0.rO)) && (this.rP === x$0.rP))));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 4;
});
$p.o = (function() {
  return "NoPanel";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.lC;
      break;
    }
    case 1: {
      return this.rN;
      break;
    }
    case 2: {
      return this.rO;
      break;
    }
    case 3: {
      return this.rP;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Ldev_cheleb_scalamigen_NoPanel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d5)));
}
export { $isArrayOf_Ldev_cheleb_scalamigen_NoPanel as $isArrayOf_Ldev_cheleb_scalamigen_NoPanel };
var $d_Ldev_cheleb_scalamigen_NoPanel = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_NoPanel, "dev.cheleb.scalamigen.NoPanel", ({
  d5: 1,
  cn: 1,
  co: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Ldev_cheleb_scalamigen_NoPanel as $d_Ldev_cheleb_scalamigen_NoPanel };
